import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const sabarBaqarah153: Quote = {
  id: "sabar-baqarah-153",
  name: "Sabar & Shalat",
  emoji: "🤲",
  category: "Sabar & Tawakkal",
  description:
    "Allah memerintahkan orang beriman untuk meminta pertolongan melalui **kesabaran dan shalat**, karena Allah senantiasa bersama orang-orang yang sabar.",
  detail:
    "Ayat ini turun sebagai pengingat bahwa ujian hidup adalah keniscayaan. Sabar bukan berarti diam tanpa usaha, tapi **keteguhan hati menghadapi cobaan** sambil terus berikhtiar. Shalat menjadi sarana mendekatkan diri kepada Allah dan memohon pertolongan-Nya.",
  tldr: "Minta pertolongan dengan sabar dan shalat — Allah bersama orang yang sabar.",
  story: createQuoteStory("Sabar & Shalat", "🤲", [
    { hook: {
      title: "Pernah merasa ujian hidup datang bertubi-tubi?",
      body: "Rasanya capek, pengen nyerah. Tapi ada satu **resep dari Allah** yang sering kita lupa...",
    } },
    { source: {
      arabic: "يَا أَيُّهَا الَّذِينَ آمَنُوا اسْتَعِينُوا بِالصَّبْرِ وَالصَّلَاةِ ۚ إِنَّ اللَّهَ مَعَ الصَّابِرِينَ",
      body: "Wahai orang-orang yang beriman, mohonlah pertolongan dengan **sabar dan shalat**. Sesungguhnya Allah bersama orang-orang yang sabar.",
      title: "QS. Al-Baqarah: 153",
    } },
    { reveal: {
      body: "Sabar bukan diam pasrah. Sabar itu **kekuatan** — bertahan di jalan yang benar meski terasa berat. Dan shalat adalah **pengingat** bahwa kamu tidak sendirian.",
    } },
    { insight: {
      title: "Kenapa sabar itu kekuatan?",
      body: "Orang yang sabar bukan berarti **tidak merasa sakit**. Mereka merasakan, tapi memilih untuk **tidak hancur karenanya**. Shalat jadi momen hening untuk kembali ingat: ada Allah yang Maha Mendengar.",
    } },
    { engagement: {
      title: "Kapan terakhir kamu merasa ujian berat banget?",
      body: "Tapi kamu tetap bertahan. **Itu sabar.** Share ayat ini ke seseorang yang sedang butuh kekuatan 💪",
    } },
  ]),
  related: ["urusan-mukmin-muslim"],
};
